
import { useQuery } from "@tanstack/react-query";
import { fetchWalletBalance } from "../../API/ProtectedAuth";
import { handleApiError } from "../../Utils/errorHandler";

export default function useWalletBalance(options = {}) {
  const { onSuccess, onError, enabled = true } = options;

  const {
    data,
    error,
    isLoading,
    refetch: reload,
  } = useQuery({
    queryKey: ["walletBalance"], 
    queryFn: async () => {
      try {
        const response = await fetchWalletBalance();
        return response;
      } catch (err) {
        handleApiError(err);
        throw err;
      }
    },
    enabled,
    staleTime: 1000 * 60 * 30, 
    cacheTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
    onSuccess,
    onError,
  });

  return {
    balance: data?.balance ?? data ?? null,
    lastUpdate: data ? new Date().toLocaleDateString("en-EG") : null,
    error,
    isLoading,
    reload,
  };
}


















































